import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2b8c4b5e&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2b8c4b5e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8c4b5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8c4b5e')) {
      api.createRecord('2b8c4b5e', component.options)
    } else {
      api.reload('2b8c4b5e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2b8c4b5e&scoped=true&lang=pug", function () {
      api.rerender('2b8c4b5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/contracts/supplementalAgreementHistory/index.vue"
export default component.exports